<template>
    <div class="filter-content-entry" data-tab="location">
        <div class="filter-content-entry-mobile-title">
            <a href="#" class="btn btn-rebrand-grey-outline btn-rebrand-xxs px-2 back">{{translate.account.onboard.back}}</a>
            <span class="filter-title">{{translate.home.location}}</span>
        </div>
        <div class="row filter-content-container">
            <div class="col-md-12">
                <mobile-search-component ref="search"></mobile-search-component>
            </div>
        </div>
    </div>
</template>

<script>

    const data = () => {
        return {
            store: $store
        };
    }

    function mounted() {
        this.unSubscribe = this.store.subscribe((mutation) => {
            if (mutation.type === 'setFilterOpened'
                && mutation.payload
            ) {
                if (!_.isEqual(this.searchRadius, this.searchRadiusTemp)) {
                    this.store.commit('setSearchRadiusTemp', _.cloneDeep(this.searchRadius));
                }
                if (typeof this.$refs.search.initSelect2 === 'function') {
                    this.$refs.search.initSelect2();
                }
            }
        });
    }

    function clearAllFilters() {
        this.store.commit('setLocationTemp', _.cloneDeep(this.location));
        this.store.commit('setSearchRadiusTemp', '20km');
    }

    export default {
        data,
        mounted,
        methods: {
            clearAllFilters,
        },
        computed: {
            ...mapState([
                'searchRadius',
                'searchRadiusTemp',
                'translate',
                'location'
            ]),
        },
        beforeDestroy() {
            if (this.unSubscribe) {
                this.unSubscribe();
            }
        },
    }
</script>
